import {
  TDexcomConnectionStatus,
  TDexcomSyncOutcome,
} from "../../../@types/admin/AdminDexcomIntegration";

type TBadgeTone = "active" | "inactive" | "warning" | "error";

export function connectionStatusTone(
  status: TDexcomConnectionStatus
): TBadgeTone {
  if (status === "Connected") return "active";
  if (status === "Pending") return "warning";
  return "inactive";
}

const OUTCOME_LABELS: Record<TDexcomSyncOutcome, string> = {
  Stored: "Stored",
  NothingNew: "Nothing new",
  Failed: "Failed",
  TokenRevoked: "Token revoked",
};

export function syncOutcomeLabel(outcome: TDexcomSyncOutcome): string {
  return OUTCOME_LABELS[outcome] ?? outcome;
}

export function syncOutcomeTone(outcome: TDexcomSyncOutcome): TBadgeTone {
  if (outcome === "Stored") return "active";
  if (outcome === "NothingNew") return "inactive";
  return "error";
}
